import React from "react";
import getRowFormettedLogoData from "../../../../../utils/getRowFormettedLogoData";
const returnLOGOHTML = (state, idx,options) => {
  const { rowCount, logoItems } = getRowFormettedLogoData(state);
  const emptyLogoStyle={
    height:(options?.block_inset==='left' || options?.block_inset==='right' ||  options?.block_inset==='sidebyside' ||  options?.side_by_side==='on' )? `${options.column_width}%`:`${options.column_width}%`,
    width: (options?.block_inset==='left' || options?.block_inset==='right' ||  options?.block_inset==='sidebyside' ||  options?.side_by_side==='on')?  `${options.column_width}%`:`${options.column_width}%`,
    borderRadius: '10px',
  }
  return logoItems.map((row) => {
    return (
      <>
        {
          row?.length ? (
            <div className="h-full w-full flex flex-row justify-evenly items-center" id={"logo_container_logo"}>
              {row?.map((logo, index) => {
                return (
                  <div key={index} id={idx + "_logo_" + index}
                    style={{
                      height: "100%",
                      width: "100%",
                      position: "relative",
                      transform: "scale(" + logo?.scale / 100 + ")",
                      top: logo?.offset_y,
                      left: logo?.offset_x,
                      borderRadius: '10px',
                    }}>
                    {logo?.thumbnail || logo?.url ? (
                      <img
                        src={logo.thumbnail || logo.url}
                        style={{
                          height: "100%",
                          width: "100%",
                        }}
                        alt="logo"
                      />
                    ) : <div className="border-for-empty-logo"
                      style={emptyLogoStyle}
                    />}
                  </div>
                );
              })}
            </div>
          ) : (null)
        }

      </>
    );
  });
};
export default function Logo({ options, items, idx }) {
  return <div className="logo_container mx-auto " 
  style={{
    width: `${options.column_width}%`,
  }}
  >{returnLOGOHTML(items, idx,options)}</div>;
}
